import { triggerEvent } from "../../services/helpers/trigger-event";

const LiveFeed = {
  selectors: {
    element: '.live',
    item: '.live-item',
    feed: '.live__feed'
  },

  nodes: {
    element: null,
    feed: null,
  },

  items: [],

  init: function() {
    let live = document.querySelector(this.selectors.element);
    if (!live) return;
    this.nodes.element = live;

    this.nodes.feed = this.nodes.element.querySelector(this.selectors.feed);

    this._addNewItems();
  },

  _addNewItems() {
    triggerEvent(document.body, "update.live");
  },

  updateFeed: function(html) {
    if (!this.nodes.feed) return;
    this.nodes.feed.insertAdjacentHTML('afterBegin', html);
    this._addNewItems();
  }
}

export default LiveFeed;